<template>
  <div>
    <mdb-modal centered @close="$store.commit('clearCurrentModal')" elegant>
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue"
          >Password Change</mdb-modal-title
        >
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="mb-4 mt-n3">
          Please fill out this form to change your password:
        </p>
        <form v-on:submit.prevent v-on:keyup.enter="submit">
          <div>
            <mdb-input
              label="Current password"
              type="password"
              v-model="passwordCurrent"
              outline
            />
            <mdb-input
              label="New password"
              type="password"
              v-model="passwordNew"
              outline
            />
            <mdb-input
              label="Retype new password"
              type="password"
              v-model="passwordNewRetype"
              outline
            />
          </div>
          <validation-info :text="validationInfo" />
          <div class="text-center">
            <mdb-btn class="btn btn-isi" @click="submit">Submit</mdb-btn>
          </div>
        </form>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
import ValidationInfo from "../ValidationInfo.vue";

export default {
  components: {
    ValidationInfo,
  },
  data() {
    return {
      passwordCurrent: null,
      passwordNew: null,
      passwordNewRetype: null,
      validationInfo: "",
    };
  },
  methods: {
    submit() {
      if (
        !this.passwordCurrent ||
        !this.passwordNew ||
        !this.passwordNewRetype
      ) {
        this.validationInfo =
          "Please fill out the form to change your password.";
        return;
      }
      if (this.passwordNew != this.passwordNewRetype) {
        this.validationInfo = "The entered passwords do not match.";
        return;
      }
      this.validationInfo = "";
      this.$http
        .post("/api/UserAction/ChangePassword", {
          passwordCurrent: this.passwordCurrent,
          passwordNew: this.passwordNew,
        })
        .then((rsp) => {
          if (rsp.data.err) {
            this.validationInfo = rsp.data.err;
            return;
          }
          this.$store.commit("setCurrentModal", {
            type: "generalInfoModal",
            options: {
              title: "Success",
              content: "Your password has been changed.",
            },
          });
        })
        .catch(() => {
          this.$store.commit("setCurrentModal", {
            type: "generalInfoModal",
            options: {
              title: "Error",
              content: "Your password could not be changed. Please try again.",
            },
          });
        });
    },
  },
};
</script>
